import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      gap: rem(12),
      flexDirection: 'column',
      justifyContent: 'space-between',
      background: 'white',
      border: `1px solid ${theme.colors.neutral100}`,
      borderRadius: rem(8),
      padding: '16px 16px',

      '.post-author, .post-content-wrapper': {
        paddingLeft: 0,
        paddingRight: 0,
      },
      '.post-content-wrapper': {
        paddingBottom: 0,
      },
      [theme.fn.largerThan('sm')]: {
        padding: '24px',
      },
      '.cursor-pointer': {
        cursor: 'pointer',
      },
    },
    customReact: {
      display: 'flex',
      alignItems: 'center',
      gap: rem(16),
    },
    reactItem: {
      display: 'flex',
      alignItems: 'center',
      gap: rem(4),
    },
  }
})
